<style lang="scss">
  @use "../../../../../assets/css/global.scss" as *;
  @use "../../../../../assets/css/_colors.scss" as *;
  .liveFeedItem {
    align-items: center;
    border-radius: 0.375rem;
    display: flex;
    gap: 0.75rem;

    &Inner {
      display: flex;
      flex-direction: column;
      gap: 0.15rem;
      justify-content: center;
      margin-bottom: 3px;

      .eventOverview {
        @extend .text-body-2-bold;
        font-size: clamp(0.8rem, 0.8vw, 0.875rem);

        a {
          color: $primary-color;

          &.eventLink {
            text-transform: capitalize;
          }

          &:hover {
            color: $dark-blue;
          }
        }
      }

      .eventDetails {
        align-items: center;
        display: flex;
        @extend .text-body-3;

        .bullet {
          font-size: 70%;
          margin: 0 0.25rem;
        }
      }
    }
  }
</style>

<script>
  import { createEventDispatcher } from "svelte";
  import { getUser } from "../../../../../assets/js/src/general/utils";
  import IconContainer from "../../../components/legacy/IconContainer.svelte";
  import Tooltip from "../../../components/legacy/Tooltip.svelte";
  import HotlistEventEngagement from "./HotlistEventEngagement.svelte";

  export let event;

  const now = parseInt(Date.now() / 1000, 10);

  const relativeTimeWithUnit = (delta, unit, unitValue) => {
    const t = Math.round(delta / unitValue);
    return t === 1 ? `${t} ${unit} ago` : `${t} ${unit}s ago`;
  };

  const relativeEventTime = (timestamp) => {
    const delta = now - timestamp;

    const second = 1;
    const minute = 60;
    const hour = 60 * 60;
    const day = 60 * 60 * 24;
    const month = 60 * 60 * 24 * 30.5;
    const year = 60 * 60 * 24 * 365.25;

    if (!timestamp) return "";

    switch (true) {
      case delta < second:
        return "Now";
      case delta < minute:
        return relativeTimeWithUnit(delta, "second", second);
      case delta < hour:
        return relativeTimeWithUnit(delta, "minute", minute);
      case delta < day:
        return relativeTimeWithUnit(delta, "hour", hour);
      case delta < month:
        return relativeTimeWithUnit(delta, "day", day);
      case delta < year:
        return relativeTimeWithUnit(delta, "month", month);
      default:
        return "Over a year ago";
    }
  };

  const dispatch = createEventDispatcher();

  const MAPPING = {
    open: { prefix: "opened", suffix: "", iconValue: "opens" },
    click: { prefix: "clicked on", suffix: "", iconValue: "clicks" },
    reply: { prefix: "replied to", suffix: "", iconValue: "replies" },
    voicemail: {
      prefix: "left a",
      suffix: ` for ${event.userName}`,
      iconValue: "voicemails",
    },
    hotlist: {
      prefix:
        getUser().userId === event.userId
          ? "was added to your"
          : `was added to ${event.userName}'s`,
      suffix: ``,
      iconValue: "hotlist",
    },
  };

  const LINK_MAP = {
    voicemail: {
      href: `/calls?callId=${event.callId}`,
      text: "voicemail",
    },
    campaign: {
      href: `/campaign?campaignId=${event.campaignId}`,
      text: event.campaignName,
    },
    hotlist: {
      href: ``,
      text: `hotlist`,
    },
  };

  $: mapObj = MAPPING[event.kind];
  $: linkObj = LINK_MAP[event.kind] || LINK_MAP.campaign;
</script>

<div class="liveFeedItem">
  <IconContainer size="md" icon={MAPPING[event.kind].iconValue} />
  <div class="liveFeedItemInner">
    <div class="eventOverview">
      {#if event.candidateId}
        <a
          data-candidateid={event.candidateId}
          href="/candidate/{event.candidateId}"
          on:click|preventDefault={() => dispatch("candidateClick", event)}
        >
          {event.candidateName}
        </a>
      {:else}
        <span>{event.candidateName}</span>
      {/if}
      {mapObj.prefix}
      {#if event.kind === "hotlist"}
        <span class="eventLink">{linkObj.text}</span>
      {:else}
        <a href={linkObj.href} class="eventLink" target="blank_">
          {linkObj.text}
        </a>
      {/if}
      {mapObj.suffix}
    </div>
    <div class="eventDetails">
      <Tooltip xPlacement="center" width="fit-content">
        <span slot="target">
          {relativeEventTime(event.timestamp)}
        </span>
        <span slot="content">
          {new Date(event.timestamp * 1000).toLocaleString()}
        </span>
      </Tooltip>
      {#if event.kind === "hotlist"}
        <HotlistEventEngagement {event} />
      {:else if event.total > 1}
        <span class="bullet">&bullet;</span> {event.total} times in total
      {/if}
    </div>
  </div>
</div>
